class DetailsDisclosure extends HTMLElement {
	constructor() {
		super();
		this.mainDetailsToggle = this.querySelector("details");

		this.addEventListener("keyup", this.onKeyUp);

		this.addEventListener("mouseover", this.mousein);
		this.addEventListener("mouseout", this.mouseout);

		this.mainDetailsToggle.addEventListener(
			"focusout",
			this.onFocusOut.bind(this)
		);
	}

	mousein(event) {
		const openDetailsElement = event.target.closest("details");
		openDetailsElement.setAttribute("open", "");
	}

	mouseout(event) {
		const openDetailsElement = event.target.closest("details[open]");
		openDetailsElement.removeAttribute("open");
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		const openDetailsElement = event.target.closest("details[open]");
		if (!openDetailsElement) return;

		const summaryElement = openDetailsElement.querySelector("summary");
		openDetailsElement.removeAttribute("open");
		summaryElement.focus();
	}

	onFocusOut() {
		setTimeout(() => {
			if (!this.contains(document.activeElement)) this.close();
		});
	}

	close() {
		this.mainDetailsToggle.removeAttribute("open");
	}
}

customElements.define('details-disclosure', DetailsDisclosure);
